// eslint-disable-next-line import/prefer-default-export
export enum InternalMovementStatus {
  NOT_STARTED = 'NOT_STARTED',
  DOING = 'DOING',
  CONCLUDED = 'CONCLUDED',
  CANCELLED = 'CANCELLED',
}
